module.exports = __webpack_public_path__ + "img/exit.153567b4.svg";